import {
    GET_INTERACTIONS,
    SET_INTERACTIONS,
    API_ERROR,
    } from "./actionTypes";
    
    export const getInteractions= (chatId) => {
      return {
        type: GET_INTERACTIONS,
        payload: {chatId},
      };
    };
    
    export const setInteractions = (chatId, data) => {
      return {
        type: SET_INTERACTIONS,
        payload: {chatId, data},
      };
    };
    
    export const apiError = (chatId, message) => {
      return {
        type: API_ERROR,
        payload: {chatId, message},
      };
    };
    